import { ChangeDetectionStrategy, Component, Type, inject } from '@angular/core';
import { Observable, filter, from, switchMap } from 'rxjs';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';

@Component({
  selector: 'custom-header-navigation',
  templateUrl: './custom-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomHeaderNavigationComponent {
  featureToggleService = inject(FeatureToggleService);
  lazyComponent$: Observable<Type<unknown>> = this.featureToggleService.enabled$('dotCmsUve').pipe(
    filter(enabled => !!enabled),
    switchMap(() =>
      from(
        import('src/app/extensions/dot-cms-uve/shared/dot-cms-uve-header/dot-cms-uve-header.component').then(
          m => m.DotCmsUveHeaderComponent
        )
      )
    )
  );
}
